(function () {
  'use strict';

  var CONFIG_ID = 'aa-exact-media-reviews-config';
  var ROOT_CLASS = 'aa-exact-media-reviews';
  var CACHE_TTL = 60 * 60 * 1000;
  var MAX_VISIBLE_REVIEWS = 8;
  var FIND_TIMEOUT = 10000;
  var REQUEST_TIMEOUT = 4000;
  var started = false;

  function track(eventName, detail) {
    var payload = Object.assign({ event: eventName }, detail || {});
    window.dispatchEvent(new CustomEvent(eventName, { detail: payload }));
    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
  }

  function eventDetail(config, extra) {
    return Object.assign({
      product_id: String(config.productId),
      product_handle: String(config.productHandle || ''),
      locale: String(config.locale || 'en'),
      device_class: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop',
      source_mode: config.sourceMode || 'loox_shared_reviews'
    }, extra || {});
  }

  function trackError(config, code) {
    track('aa_exact_media_reviews_error', eventDetail(config, { error_code: code }));
  }

  function decodeText(value) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = String(value || '');
    return textarea.value;
  }

  function parseConfig() {
    var node = document.getElementById(CONFIG_ID);
    if (!node) return null;
    try {
      var config = JSON.parse(node.textContent);
      if (config.copy) {
        Object.keys(config.copy).forEach(function (key) {
          if (typeof config.copy[key] === 'string') config.copy[key] = decodeText(config.copy[key]);
        });
      }
      return config.productId && config.publicStoreId && config.copy ? config : null;
    } catch (error) {
      return null;
    }
  }

  function findLooxWidget(callback) {
    var selector = '#looxReviews[data-product-id]';
    var match = document.querySelector(selector);
    if (match) return callback(match);

    var observer = new MutationObserver(function () {
      var found = document.querySelector(selector);
      if (!found) return;
      observer.disconnect();
      callback(found);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, FIND_TIMEOUT);
  }

  function exactReviewCount(payload) {
    var total = payload && payload.pagination ? Number(payload.pagination.total) : NaN;
    return Number.isFinite(total) && total >= 0 ? total : null;
  }

  function displayedProductReviewCount(config) {
    var productInfo = document.querySelector('[id^="product-info-' + String(config.productId) + '-"]');
    if (!productInfo) return null;
    var rating = productInfo.querySelector('.loox-rating[data-raters]');
    if (!rating) return null;
    var raters = Number(rating.getAttribute('data-raters'));
    return Number.isFinite(raters) && raters >= 0 ? raters : null;
  }

  function isSharedReviewWidget(config, looxNode, payload) {
    if (looxNode.hasAttribute('data-loox-aggregate')) return true;

    var exactCount = exactReviewCount(payload);
    var displayedCount = displayedProductReviewCount(config);
    if (exactCount === null || displayedCount === null) return false;

    // Loox product groups do not expose data-loox-aggregate. Their PDP rating
    // total still includes the group, so compare it with the exact-product API.
    return displayedCount > exactCount;
  }

  function normalizedSectionText(node) {
    return node && node.innerText ? node.innerText.trim().replace(/\s+/g, ' ').toLowerCase() : '';
  }

  function isHeadingOnlyRichTextSection(node) {
    if (!node || !node.classList || !node.classList.contains('shopify-section--rich-text')) return false;
    if (node.querySelector('a, button, img, picture, video, iframe, form, input, select, textarea')) return false;

    var headings = node.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"], .h1, .h2, .h3, .h4, .h5, .h6');
    if (headings.length !== 1) return false;

    var sectionText = normalizedSectionText(node);
    var headingText = normalizedSectionText(headings[0]);
    return Boolean(sectionText && headingText && sectionText === headingText);
  }

  function isReviewHeadingSection(node, config) {
    if (!isHeadingOnlyRichTextSection(node)) return false;

    var text = normalizedSectionText(node);
    var configuredHeadings = [config.copy.allReviews, config.copy.featuredVideoReviews].filter(Boolean).map(function (value) {
      return String(value).trim().replace(/\s+/g, ' ').toLowerCase();
    });
    if (configuredHeadings.indexOf(text) !== -1) return true;

    // Covers the storefront languages currently supported by this component.
    return /\breviews\b|bewertungen?|rezensionen?|\bavis\b|reseñas?|opiniones?|recensioni|anmeldelser?|avaliações?/i.test(text);
  }

  function isLooxVideoSliderSection(node) {
    return Boolean(node && node.querySelector && node.querySelector('loox-video-slider-widget'));
  }

  function isReviewClusterBridge(node, config) {
    if (!node || !node.classList) return false;
    if (isReviewHeadingSection(node, config)) return true;
    if (node.classList.contains('shopify-section--testimonials')) return true;

    // Older PDPs place a short review-proof rich-text block between the Loox
    // video slider and testimonials. Do not cross other section types.
    return node.classList.contains('shopify-section--rich-text') &&
      /\breviews\b|bewertungen?|rezensionen?|\bavis\b|reseñas?|opiniones?|recensioni|anmeldelser?|avaliações?/i.test(normalizedSectionText(node));
  }

  function reviewInsertionTarget(looxSection, config) {
    var insertionTarget = looxSection;
    var precedingSection = looxSection.previousElementSibling;

    // Keep a dedicated review heading attached to Loox below this component.
    if (isReviewHeadingSection(precedingSection, config)) insertionTarget = precedingSection;

    // When a Loox video carousel appears earlier in the same review cluster,
    // the exact-product media belongs before that carousel and its heading.
    var sectionsChecked = 0;
    while (precedingSection && sectionsChecked < 12) {
      if (isLooxVideoSliderSection(precedingSection)) {
        insertionTarget = precedingSection;
        var videoHeading = precedingSection.previousElementSibling;
        if (isReviewHeadingSection(videoHeading, config)) insertionTarget = videoHeading;
        break;
      }

      if (!isReviewClusterBridge(precedingSection, config)) break;

      precedingSection = precedingSection.previousElementSibling;
      sectionsChecked += 1;
    }

    return insertionTarget;
  }

  function cacheKey(config) {
    return 'aa-emr:v2:' + config.productId + ':' + config.locale;
  }

  function cacheRead(config) {
    try {
      var raw = window.sessionStorage.getItem(cacheKey(config));
      if (!raw) return null;
      var cached = JSON.parse(raw);
      return Date.now() - cached.savedAt < CACHE_TTL ? cached.payload : null;
    } catch (error) {
      return null;
    }
  }

  function cacheWrite(config, payload) {
    try {
      window.sessionStorage.setItem(cacheKey(config), JSON.stringify({ savedAt: Date.now(), payload: payload }));
    } catch (error) {
      return;
    }
  }

  function isAllowedMedia(media) {
    if (!media || (media.type !== 'photo' && media.type !== 'video') || typeof media.url !== 'string') return false;
    try {
      var parsed = new URL(media.url);
      if (parsed.protocol !== 'https:') return false;
      if (media.type === 'photo') return parsed.hostname === 'images.loox.io';
      return parsed.hostname === 'iframe.videodelivery.net' || parsed.hostname.endsWith('.videodelivery.net') || parsed.hostname.endsWith('.cloudflarestream.com');
    } catch (error) {
      return false;
    }
  }

  function mediaReviews(payload, productId) {
    if (!payload || !Array.isArray(payload.reviews)) return [];
    return payload.reviews.reduce(function (result, review) {
      if (!review || !review.product || String(review.product.id) !== String(productId)) return result;
      var media = Array.isArray(review.media) ? review.media.filter(isAllowedMedia) : [];
      if (!media.length) return result;
      result.push({
        id: String(review.id || ''),
        rating: Math.max(1, Math.min(5, Number(review.rating) || 5)),
        body: typeof review.body === 'string' ? review.body.trim() : '',
        verified: review.verified === true,
        reviewer: review.reviewer && typeof review.reviewer.name === 'string' ? review.reviewer.name : '',
        date: typeof (review.date || review.createdAt) === 'string' ? (review.date || review.createdAt) : '',
        media: media
      });
      return result;
    }, []);
  }

  function request(config, attempt, cacheBuster) {
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT);
    var base = 'https://storefront-api.loox.io/storefront/v1/store/' + encodeURIComponent(config.publicStoreId);
    var query = '?product_id=' + encodeURIComponent(config.productId) + '&sort=featured&limit=250&locale=' + encodeURIComponent(config.locale || 'en');
    if (cacheBuster) query += '&aa_exact_count=' + encodeURIComponent(cacheBuster);
    var requestOptions = { signal: controller.signal, credentials: 'omit' };
    if (cacheBuster) requestOptions.cache = 'no-store';

    return fetch(base + '/product-reviews' + query, requestOptions)
      .then(function (response) {
        if (!response.ok) {
          var retryable = response.status >= 500;
          var error = new Error('Loox request failed');
          error.retryable = retryable;
          throw error;
        }
        return response.json();
      })
      .finally(function () { window.clearTimeout(timeout); })
      .catch(function (error) {
        if (attempt < 1 && (error.name === 'AbortError' || error.retryable || error instanceof TypeError)) {
          return request(config, attempt + 1, cacheBuster);
        }
        throw error;
      });
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  }

  function ratingLabel(copy, rating) {
    return copy.rating.replace('__RATING__', String(rating));
  }

  function stars(rating, copy) {
    var node = element('span', ROOT_CLASS + '__stars', '★★★★★'.slice(0, Math.round(rating)));
    node.setAttribute('role', 'img');
    node.setAttribute('aria-label', ratingLabel(copy, rating));
    return node;
  }

  function formatDate(review, config) {
    if (!review.date) return '';
    var date = new Date(review.date);
    if (Number.isNaN(date.getTime())) return '';
    try {
      return new Intl.DateTimeFormat(config.locale || 'en', { month: 'long', year: 'numeric' }).format(date);
    } catch (error) {
      return new Intl.DateTimeFormat('en', { month: 'long', year: 'numeric' }).format(date);
    }
  }

  function appendReviewContent(container, review, config, inDialog) {
    var meta = element('div', ROOT_CLASS + '__meta');
    var date = formatDate(review, config);
    meta.appendChild(stars(review.rating, config.copy));
    if (review.verified) meta.appendChild(element('span', ROOT_CLASS + '__verified', config.copy.verified));
    if (date) meta.appendChild(element('time', ROOT_CLASS + '__date', date));
    container.appendChild(meta);
    if (review.body) {
      container.appendChild(element('blockquote', inDialog ? ROOT_CLASS + '__dialog-quote' : ROOT_CLASS + '__quote', '“' + review.body + '”'));
    }
    if (review.reviewer) container.appendChild(element('p', ROOT_CLASS + '__reviewer', review.reviewer));
  }

  function mediaPreview(media, config) {
    var image = element('img', ROOT_CLASS + '__media');
    image.loading = 'lazy';
    image.decoding = 'async';
    image.alt = '';
    if (media.type === 'photo') {
      image.src = media.url;
    } else if (media.thumbnailUrl && isAllowedMedia({ type: 'photo', url: media.thumbnailUrl })) {
      image.src = media.thumbnailUrl;
    } else {
      image.removeAttribute('src');
    }
    return image;
  }

  function renderDialog(root, items, config) {
    var dialog = element('dialog', ROOT_CLASS + '__dialog');
    dialog.setAttribute('aria-label', config.copy.heading);
    var panel = element('div', ROOT_CLASS + '__dialog-panel');
    var stage = element('div', ROOT_CLASS + '__dialog-stage');
    var details = element('div', ROOT_CLASS + '__dialog-content');
    var close = element('button', ROOT_CLASS + '__dialog-button ' + ROOT_CLASS + '__dialog-close', '×');
    var previous = element('button', ROOT_CLASS + '__dialog-button ' + ROOT_CLASS + '__dialog-prev', '‹');
    var next = element('button', ROOT_CLASS + '__dialog-button ' + ROOT_CLASS + '__dialog-next', '›');
    var activeIndex = 0;
    var returnFocus = null;
    var previousBodyOverflow = '';

    close.type = previous.type = next.type = 'button';
    close.setAttribute('aria-label', config.copy.close);
    previous.setAttribute('aria-label', config.copy.previous);
    next.setAttribute('aria-label', config.copy.next);

    function display(index) {
      activeIndex = (index + items.length) % items.length;
      while (stage.firstChild) stage.removeChild(stage.firstChild);
      while (details.firstChild) details.removeChild(details.firstChild);
      var item = items[activeIndex];
      var media = item.media;
      var mediaNode;
      if (media.type === 'photo') {
        mediaNode = element('img', ROOT_CLASS + '__dialog-media');
        mediaNode.src = media.url;
        mediaNode.alt = config.copy.openPhoto;
      } else if (media.url.indexOf('videodelivery.net') > -1 || media.url.indexOf('cloudflarestream.com') > -1) {
        mediaNode = element('iframe', ROOT_CLASS + '__dialog-media');
        mediaNode.src = media.url;
        mediaNode.title = config.copy.playVideo;
        mediaNode.allow = 'accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture';
        mediaNode.allowFullscreen = true;
      } else {
        mediaNode = element('video', ROOT_CLASS + '__dialog-media');
        mediaNode.src = media.url;
        mediaNode.controls = true;
      }
      stage.appendChild(mediaNode);
      appendReviewContent(details, item.review, config, true);
      previous.hidden = items.length < 2;
      next.hidden = items.length < 2;
    }

    close.addEventListener('click', function () { dialog.close(); });
    previous.addEventListener('click', function () { display(activeIndex - 1); });
    next.addEventListener('click', function () { display(activeIndex + 1); });
    dialog.addEventListener('close', function () {
      while (stage.firstChild) stage.removeChild(stage.firstChild);
      while (details.firstChild) details.removeChild(details.firstChild);
      document.body.style.overflow = previousBodyOverflow;
      if (returnFocus) returnFocus.focus();
    });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(dialog.querySelectorAll('button:not([hidden]), [href], iframe, video[controls], [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    panel.appendChild(stage);
    panel.appendChild(details);
    dialog.appendChild(panel);
    dialog.appendChild(close);
    dialog.appendChild(previous);
    dialog.appendChild(next);
    root.appendChild(dialog);

    return function open(index, opener) {
      returnFocus = opener;
      display(index);
      previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      close.focus();
      track('aa_exact_media_review_opened', eventDetail(config, { media_index: activeIndex }));
      if (items[activeIndex].media.type === 'video') {
        track('aa_exact_media_review_video_played', eventDetail(config, { media_index: activeIndex }));
      }
    };
  }

  function render(config, reviews, looxNode, mount) {
    if (!reviews.length || (mount ? mount.host.querySelector('.' + ROOT_CLASS) : document.querySelector('.' + ROOT_CLASS))) return;
    var eligibleAssetCount = reviews.reduce(function (total, review) { return total + review.media.length; }, 0);
    track('aa_exact_media_reviews_eligible', eventDetail(config, {
      media_review_count: reviews.length,
      media_asset_count: eligibleAssetCount
    }));

    var section = element('section', ROOT_CLASS);
    var headingId = mount ? 'aa-offer-media-reviews-heading-' + String(config.productId) : 'aa-exact-media-reviews-heading';
    section.setAttribute('aria-labelledby', headingId);
    var inner = element('div', ROOT_CLASS + '__inner');
    var header = element('header', ROOT_CLASS + '__header');
    var eyebrow = element('p', ROOT_CLASS + '__eyebrow', config.copy.eyebrow);
    var heading = element('h2', ROOT_CLASS + '__heading', config.copy.heading);
    var support = element('p', ROOT_CLASS + '__support', config.copy.support);
    var carousel = element('div', ROOT_CLASS + '__carousel');
    var controls = element('div', ROOT_CLASS + '__carousel-controls');
    var status = element('span', ROOT_CLASS + '__carousel-status');
    var previousReviews = element('button', ROOT_CLASS + '__carousel-button', '‹');
    var nextReviews = element('button', ROOT_CLASS + '__carousel-button', '›');
    var grid = element('div', ROOT_CLASS + '__grid');
    var allMedia = [];
    var visibleReviews = reviews.slice(0, MAX_VISIBLE_REVIEWS);

    reviews.forEach(function (review) {
      review.mediaStartIndex = allMedia.length;
      review.media.forEach(function (media) {
        allMedia.push({ media: media, review: review });
      });
    });

    heading.id = headingId;
    carousel.dataset.count = String(visibleReviews.length);
    controls.dataset.count = String(visibleReviews.length);
    grid.dataset.count = String(visibleReviews.length);
    grid.tabIndex = 0;
    grid.setAttribute('role', 'region');
    grid.setAttribute('aria-label', config.copy.heading);
    previousReviews.type = 'button';
    previousReviews.setAttribute('aria-label', config.copy.previous);
    nextReviews.type = 'button';
    nextReviews.setAttribute('aria-label', config.copy.next);
    status.setAttribute('aria-live', 'polite');
    controls.appendChild(status);
    controls.appendChild(previousReviews);
    controls.appendChild(nextReviews);
    carousel.appendChild(controls);
    carousel.appendChild(grid);
    header.appendChild(eyebrow);
    header.appendChild(heading);
    header.appendChild(support);
    inner.appendChild(header);
    inner.appendChild(carousel);
    section.appendChild(inner);

    visibleReviews.forEach(function (review) {
      var card = element('article', ROOT_CLASS + '__card');
      var button = element('button', ROOT_CLASS + '__media-button');
      var firstMedia = review.media[0];
      var mediaIndex = review.mediaStartIndex;
      button.type = 'button';
      button.setAttribute('aria-label', firstMedia.type === 'video' ? config.copy.playVideo : config.copy.openPhoto);
      button.appendChild(mediaPreview(firstMedia, config));
      button.appendChild(element('span', ROOT_CLASS + '__media-badge', firstMedia.type === 'video' ? '▶ ' + config.copy.video : config.copy.photo));
      if (review.media.length > 1) {
        button.appendChild(element('span', ROOT_CLASS + '__asset-count', config.copy.mediaCount.replace('__COUNT__', String(review.media.length))));
      }

      var content = element('div', ROOT_CLASS + '__content');
      appendReviewContent(content, review, config, false);
      card.appendChild(button);
      card.appendChild(content);
      grid.appendChild(card);
      button.dataset.mediaIndex = String(mediaIndex);
    });

    function carouselStep() {
      var card = grid.querySelector('.' + ROOT_CLASS + '__card');
      if (!card) return 0;
      var gridStyle = window.getComputedStyle(grid);
      return card.getBoundingClientRect().width + (parseFloat(gridStyle.columnGap || gridStyle.gap) || 0);
    }

    function updateCarouselControls() {
      var step = carouselStep();
      var maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
      var firstVisible = step ? Math.round(grid.scrollLeft / step) : 0;
      var cardsPerView = mount ? Math.max(1, Math.floor((grid.clientWidth + 1) / Math.max(1, step))) : window.matchMedia('(min-width: 750px)').matches ? Math.min(3, visibleReviews.length) : 1;
      var lastVisible = Math.min(visibleReviews.length, firstVisible + cardsPerView);
      status.textContent = String(firstVisible + 1) + (lastVisible > firstVisible + 1 ? '–' + String(lastVisible) : '') + ' / ' + String(visibleReviews.length);
      previousReviews.disabled = grid.scrollLeft <= 2;
      nextReviews.disabled = grid.scrollLeft >= maxScroll - 2;
    }

    function moveCarousel(direction) {
      grid.scrollBy({
        left: direction * carouselStep(),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    previousReviews.addEventListener('click', function () { moveCarousel(-1); });
    nextReviews.addEventListener('click', function () { moveCarousel(1); });
    grid.addEventListener('scroll', function () { window.requestAnimationFrame(updateCarouselControls); }, { passive: true });
    window.addEventListener('resize', updateCarouselControls, mount ? { signal: mount.signal } : undefined);

    if (!mount) {
    var footer = element('div', ROOT_CLASS + '__footer');
    var more = element('button', ROOT_CLASS + '__more', config.copy.moreReviews);
    more.type = 'button';
    more.addEventListener('click', function () {
      looxNode.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      track('aa_exact_media_reviews_bridge_clicked', eventDetail(config, {
        media_review_count: reviews.length,
        media_asset_count: allMedia.length
      }));
    });
    footer.appendChild(more);
    inner.appendChild(footer);

    var looxSection = looxNode.closest('.shopify-section') || looxNode.parentElement;
    if (!looxSection || !looxSection.parentNode) return;
    var insertionTarget = reviewInsertionTarget(looxSection, config);
    insertionTarget.parentNode.insertBefore(section, insertionTarget);
    } else {
      mount.host.hidden = false;
      mount.host.appendChild(section);
    }
    window.requestAnimationFrame(updateCarouselControls);

    var openDialog = renderDialog(section, allMedia, config);
    grid.addEventListener('click', function (event) {
      var opener = event.target.closest('.' + ROOT_CLASS + '__media-button');
      if (!opener) return;
      openDialog(Number(opener.dataset.mediaIndex) || 0, opener);
    });
    track('aa_exact_media_reviews_rendered', eventDetail(config, {
      media_review_count: reviews.length,
      media_asset_count: allMedia.length
    }));
  }

  function load(config, looxNode) {
    function handlePayload(payload, errorCode) {
      if (!payload || !Array.isArray(payload.reviews)) {
        trackError(config, errorCode);
        return;
      }
      if (!isSharedReviewWidget(config, looxNode, payload)) return;
      render(config, mediaReviews(payload, config.productId), looxNode);
    }

    // Product-group eligibility is inferred by comparing the rendered Loox
    // count with the exact API total, so never compare that live DOM value with
    // a stale cached total. Explicit aggregate mode does not need this inference.
    var usesCountInference = !looxNode.hasAttribute('data-loox-aggregate');
    var cacheBuster = usesCountInference ? Date.now() + '-' + Math.random().toString(36).slice(2) : '';
    var cached = usesCountInference ? null : cacheRead(config);
    if (cached) {
      handlePayload(cached, 'malformed_cached_response');
      return;
    }
    request(config, 0, cacheBuster).then(function (payload) {
      if (!payload || !Array.isArray(payload.reviews)) {
        trackError(config, 'malformed_api_response');
        return;
      }
      if (!usesCountInference) cacheWrite(config, payload);
      if (!isSharedReviewWidget(config, looxNode, payload)) return;
      render(config, mediaReviews(payload, config.productId), looxNode);
    }).catch(function () { trackError(config, 'api_request_failed'); });
  }

  // The builder supplies an explicit exact-product host. PDP eligibility is unchanged.
  window.AAExactMediaReviews = Object.freeze({
    mount: function (config, host, scrollRoot) {
      var controller = new AbortController();
      var observer = null;
      var active = true;
      host.hidden = true;
      host.replaceChildren();
      function show(payload) {
        if (!active || !host.isConnected || !scrollRoot.open && scrollRoot.tagName === 'DIALOG') return;
        if (!payload || !Array.isArray(payload.reviews)) return;
        render(config, mediaReviews(payload, config.productId), null, { host: host, signal: controller.signal });
      }
      function loadExact() {
        var cached = cacheRead(config);
        if (cached) return show(cached);
        request(config, 0).then(function (payload) {
          if (!active) return;
          if (payload && Array.isArray(payload.reviews)) cacheWrite(config, payload);
          show(payload);
        }).catch(function () { if (active) trackError(config, 'api_request_failed'); });
      }
      // Review data is deferred until the lower modal approaches the viewport.
      // The options and Add button never wait for the review service.
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          observer.disconnect();
          loadExact();
        }, { root: scrollRoot, rootMargin: '200px 0px' });
        // Observe the visible details row preceding the hidden review host.
        observer.observe(host.previousElementSibling || scrollRoot);
      } else loadExact();
      return function unmount() {
        active = false;
        controller.abort();
        if (observer) observer.disconnect();
        host.querySelectorAll('dialog[open]').forEach(function (dialog) { dialog.close(); });
        host.replaceChildren();
        host.hidden = true;
      };
    }
  });

  function init() {
    if (started) return;
    started = true;
    var config = parseConfig();
    if (!config) return;
    findLooxWidget(function (looxNode) {
      if (String(looxNode.getAttribute('data-product-id')) !== String(config.productId)) {
        trackError(config, 'product_id_mismatch');
        return;
      }
      var trigger = looxNode.closest('.shopify-section') || looxNode;
      if (!('IntersectionObserver' in window)) return load(config, looxNode);
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        load(config, looxNode);
      }, { rootMargin: '600px 0px' });
      observer.observe(trigger);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
